import React, { useState, useRef, useEffect } from "react";
import { useToast } from "../../contexts/ToastContext";

const ShareScriptPopover = () => {
  const { showToast } = useToast();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (anchorRef.current && !anchorRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleCopyLink = () => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    navigator.clipboard.writeText(url).then(() => {
      setOpen(false);
      showToast("Link copied!");
    });
  };

  return (
    <div className="relative" ref={anchorRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1.5 px-3 py-2 rounded border text-theme-text text-sm focus:outline-none focus:ring-2 focus:ring-theme-primary ${
          open
            ? "border-theme-secondary bg-theme-secondary"
            : "border-theme-secondary hover:bg-theme-secondary"
        }`}
        aria-expanded={open}
        aria-haspopup="true"
        aria-label="Share"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        <span>Share</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 z-30 w-64 rounded-lg border border-theme-secondary bg-theme-main shadow-lg p-4">
          <p className="text-sm font-medium text-theme-text mb-1">Share</p>
          <p className="text-xs text-theme-text opacity-70 mb-3">
            Copy a link to this page to share with others.
          </p>
          <button
            type="button"
            onClick={handleCopyLink}
            className="w-full py-2 rounded bg-theme-primary text-theme-button text-sm font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-theme-primary"
          >
            Copy link
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareScriptPopover;
